var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#32A6DC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,66.3h-2.8c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.8c0.8,0,1.4-0.6,1.4-1.4V48.2c0-0.3-0.1-0.7-0.3-0.9L72.9,30.7 c-0.3-0.3-0.6-0.5-1-0.5h-14v34.1h12.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H56.9c-0.6,0-1-0.4-1-1V29.2c0-0.6,0.4-1,1-1h15 c1,0,1.9,0.4,2.5,1.1l14.7,16.6c0.5,0.6,0.9,1.4,0.9,2.2V63C90,64.8,88.5,66.3,86.6,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,66.3H28.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h27.3V48.3H2v13.9c0,1.2,0.7,2.2,1.6,2.2h11.8c0.6,0,1,0.4,1,1 s-0.4,1-1,1H3.6c-2,0-3.6-1.9-3.6-4.2V47.3c0-0.6,0.4-1,1-1h55.9c0.6,0,1,0.4,1,1v18.1C57.9,65.9,57.5,66.3,56.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,72.6c-4.2,0-7.7-3.4-7.7-7.7s3.4-7.7,7.7-7.7s7.7,3.4,7.7,7.7S81.4,72.6,77.2,72.6z M77.2,59.3 c-3.1,0-5.7,2.5-5.7,5.7c0,3.1,2.5,5.7,5.7,5.7s5.7-2.5,5.7-5.7S80.3,59.3,77.2,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,72.6c-4.2,0-7.7-3.4-7.7-7.7s3.4-7.7,7.7-7.7s7.7,3.4,7.7,7.7S26.2,72.6,22,72.6z M22,59.3 c-3.1,0-5.7,2.5-5.7,5.7c0,3.1,2.5,5.7,5.7,5.7s5.7-2.5,5.7-5.7S25.1,59.3,22,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,48.3H68.2c-1.7,0-3.1-1.4-3.1-3.1v-7.9c0-1.7,1.4-3.1,3.1-3.1h10c0.6,0,1,0.4,1,1s-0.4,1-1,1h-10 c-0.6,0-1.1,0.5-1.1,1.1v7.9c0,0.6,0.5,1.1,1.1,1.1H89c0.6,0,1,0.4,1,1S89.6,48.3,89,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,48.3H1c-0.6,0-1-0.4-1-1V31.8c0-0.6,0.4-1,1-1h15.5c0.6,0,1,0.4,1,1v15.5C17.5,47.8,17,48.3,16.5,48.3z  M2,46.3h13.5V32.8H2V46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,48.3H16.5c-0.6,0-1-0.4-1-1v-9.8c0-0.6,0.4-1,1-1H34c0.6,0,1,0.4,1,1v9.8C35,47.8,34.5,48.3,34,48.3z  M17.5,46.3H33v-7.8H17.5V46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,48.3H34c-0.6,0-1-0.4-1-1V33c0-0.6,0.4-1,1-1h22.9c0.6,0,1,0.4,1,1v14.2C57.9,47.8,57.5,48.3,56.9,48.3z  M35,46.3h20.9V34H35V46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,34H34c-0.6,0-1-0.4-1-1V18.4c0-0.6,0.4-1,1-1h22.9c0.6,0,1,0.4,1,1V33C57.9,33.6,57.5,34,56.9,34z  M35,32h20.9V19.4H35V32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,38.5H16.5c-0.6,0-1-0.4-1-1V25.7c0-0.6,0.4-1,1-1H34c0.6,0,1,0.4,1,1v11.8C35,38,34.5,38.5,34,38.5z  M17.5,36.5H33v-9.8H17.5V36.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 77.2,
    cy: 65,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 65,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,37.8c-0.1,0-0.2,0-0.3,0l-2.9-0.9l-2.9,0.9c-0.3,0.1-0.6,0-0.9-0.1s-0.4-0.5-0.4-0.8v-5.1 c0-0.6,0.4-1,1-1h6.4c0.6,0,1,0.4,1,1v5.1c0,0.3-0.2,0.6-0.4,0.8C12.4,37.8,12.1,37.8,11.9,37.8z M8.7,34.8c0.1,0,0.2,0,0.3,0 l1.9,0.6v-2.7H6.5v2.7l1.9-0.6C8.5,34.9,8.6,34.8,8.7,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,31.8c-0.1,0-0.2,0-0.3,0l-2.9-0.9l-2.9,0.9c-0.3,0.1-0.6,0-0.9-0.1c-0.3-0.2-0.4-0.5-0.4-0.8v-5.1 c0-0.6,0.4-1,1-1h6.4c0.6,0,1,0.4,1,1v5.1c0,0.3-0.2,0.6-0.4,0.8C28.8,31.7,28.6,31.8,28.4,31.8z M25.2,28.8c0.1,0,0.2,0,0.3,0 l1.9,0.6v-2.7H23v2.7l1.9-0.6C25,28.8,25.1,28.8,25.2,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,43.5c-0.1,0-0.2,0-0.3,0l-2.9-0.9l-2.9,0.9c-0.3,0.1-0.6,0-0.9-0.1S21,42.8,21,42.5v-5.1 c0-0.6,0.4-1,1-1h6.4c0.6,0,1,0.4,1,1v5.1c0,0.3-0.2,0.6-0.4,0.8C28.8,43.5,28.6,43.5,28.4,43.5z M25.2,40.5c0.1,0,0.2,0,0.3,0 l1.9,0.6v-2.7H23v2.7l1.9-0.6C25,40.5,25.1,40.5,25.2,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,24.4c-0.1,0-0.2,0-0.3,0l-2.9-0.9l-2.9,0.9c-0.3,0.1-0.6,0-0.9-0.1c-0.3-0.2-0.4-0.5-0.4-0.8v-5.1 c0-0.6,0.4-1,1-1h6.4c0.6,0,1,0.4,1,1v5.1c0,0.3-0.2,0.6-0.4,0.8C49.1,24.3,48.8,24.4,48.6,24.4z M45.4,21.4c0.1,0,0.2,0,0.3,0 l1.9,0.6v-2.7h-4.4v2.7l1.9-0.6C45.2,21.4,45.3,21.4,45.4,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,39.1c-0.1,0-0.2,0-0.3,0l-2.9-0.9L42.6,39c-0.3,0.1-0.6,0-0.9-0.1s-0.4-0.5-0.4-0.8V33c0-0.6,0.4-1,1-1 h6.4c0.6,0,1,0.4,1,1v5.1c0,0.3-0.2,0.6-0.4,0.8C49.1,39,48.8,39.1,48.6,39.1z M45.4,36.1c0.1,0,0.2,0,0.3,0l1.9,0.6V34h-4.4v2.7 l1.9-0.6C45.2,36.1,45.3,36.1,45.4,36.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotos);
export default __webpack_public_path__ + "static/media/motos.b4a8996f2cfaca7dfb0eac9ba1293246.svg";
export { ForwardRef as ReactComponent };